import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { getValueByPath } from 'helpers/utils';
import { Form } from 'react-bootstrap';
import { InputProps, Props } from './input.type';

const InputField = ({ field, form, icon, ...props }: InputProps) => {
  const isError = Boolean(
    getValueByPath(form.errors, field.name) &&
      getValueByPath(form.touched, field.name)
  );

  return (
    <>
      <Form.Control {...field} {...props} isInvalid={isError} />
      {icon && icon}
    </>
  );
};

export default function Input(props: Props) {
  return (
    <>
      <Field {...props} component={InputField} />
      {!props.hideMessage && (
        <ErrorMessage
          name={props.name}
          component="div"
          className="invalid-feedback"
        />
      )}
    </>
  );
}
